<template>
  <div class="background_white">
    <div class="container flex items-center flex-wrap">
      <div class="col-12 md-col-6 flex items-center text_partners">
        <div class="italic black caps width_6 h2 bigger" v-html="$store.state.translations.ils_nous_font_confiance_chaque_jour"></div>
      </div>
      <div class="col-12 md-col-6 center margin_picture">
        <img src="/images/clients.png" alt="Nos clients" style="width: 600px; max-width: 100%;"/>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "brands"
  };
</script>

<style scoped>

</style>